// extracted by mini-css-extract-plugin
module.exports = {"user":"MemberRow_user__1I6Hn","userName":"MemberRow_userName__1x1__","groupImage":"MemberRow_groupImage__3E2de"};